import {FC, useState, createContext, useContext} from 'react'
import {WithChildren} from '../../../../../template/_metronic/helpers'
import {ListViewContextProps, initialListView} from '../../../../../interfaces/user'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [userIdForUpdate, setUserIdForUpdate] = useState<string | undefined>(
    initialListView.userIdForUpdate
  )

  const [userIdForDelete, setUserIdForDelete] = useState<string | undefined>(
    initialListView.userIdForDelete
  )

  return (
    <ListViewContext.Provider
      value={{
        userIdForUpdate,
        setUserIdForUpdate,
        userIdForDelete,
        setUserIdForDelete,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
